import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { catchError, tap, switchMap } from 'rxjs/operators';

import { Vehicle } from '../shared/models/Vehicle';
import { VEHICLE_URL } from '../shared/constats/urls';
import { TankService } from './tank.service';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {

  constructor(
    private http: HttpClient,
    private toastrService: ToastrService,
    private tankService: TankService
  ) { }

  private assignTankId(vehicle: Vehicle): Observable<Vehicle> {
    return this.tankService.getCurrentTank().pipe(
      switchMap(tank => {
        vehicle.tankId = tank.id;
        return this.http.post<Vehicle>(VEHICLE_URL + '/', vehicle);
      })
    );
  }

  saveVehicle(vehicle: Vehicle): Observable<any> {
    return this.assignTankId(vehicle).pipe(
      catchError((error) => {
        this.toastrService.error('Error al guardar el vehiculo', 'Error');
        throw error;
      }),
      tap(() => {
        this.toastrService.success('vehiculo guardado con éxito', 'Éxito');
      })
    );
  }

  /* editVehicle(id: Number, vehicle: Vehicle): Observable<any> {
        return this.assignTankId(vehicle).pipe(
       switchMap(() => this.http.put(VEHICLE_URL + '/' + id, vehicle))
     );
   }*/

  editVehicle(id: number, vehicle: Vehicle): Observable<any> {
    return this.http.put(VEHICLE_URL + '/' + id, vehicle);
  }

  getAll(): Observable<Vehicle[]> {
    return this.http.get<Vehicle[]>(VEHICLE_URL);
  }

  getVehicle(id: Number): Observable<Vehicle> {
    return this.http.get<Vehicle>(VEHICLE_URL + '/' + id);
  }

  deleteVehicle(id: Number, tankId: Number): Observable<any> {
    return this.http.delete(VEHICLE_URL + '/' + id+'/' + tankId);
  }

  getVehicleByTank(id: Number): Observable<Vehicle[]> {
    return this.http.get<Vehicle[]>(VEHICLE_URL + '/getVehicleByTank/' + id);
  }

  getVehicleByTankWithPagination(tankId: number, page: number): Observable<any> {
    return this.http.get(`${VEHICLE_URL}/getVehicleByTank/${tankId}/${page}`);
  }

}
